import { render, staticRenderFns } from "./add.vue?vue&type=template&id=109e00e1&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=109e00e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109e00e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109e00e1')) {
      api.createRecord('109e00e1', component.options)
    } else {
      api.reload('109e00e1', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=109e00e1&scoped=true&", function () {
      api.rerender('109e00e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/region/add.vue"
export default component.exports